<!--Usage:

HTML:

    <OverlayObjects :overlays="overlays1" bg="/assets/scenes/classroom001.jpg" bgwidth="734" bgheight="370" alt="Une classe préscolaire avec des livres et des jouets"></OverlayObjects>

Javascript:

    overlays1: [
        {
            id: "sac",
            x: 635,
            y: 190,
            width: 6,
            image: "objects/bag.png",
            alt: "un sac"
        },
        {
            id: "cup",
            x: 212,
            y: 223,
            width: 4,
            image: "objects/blueCup.png",
            alt: "verre de crayons"
        },
        {
            id: "dino",
            x: 321,
            y: 84,
            width: 5.313351,
            image: "objects/dinosaur.png",
            alt: "verre de crayons"
        }
    ],,-->

<template>
  <div class="overlay-objects-container center-image">
    <img v-if="labelledby" :src="getBackgroundImage(bg)" :class="getObjectDrawMode(false, true, false, null, true, false)" :alt="alt" :aria-labelledby="labelledby" :aria-describedby="describedby" />
    <img v-if="!labelledby" :src="getBackgroundImage(bg)" :class="getObjectDrawMode(false, true, false, null, true, false)" :alt="alt" />
    <div v-for="(overlay, index) in overlays" :key="overlay.id">
      <div :style="getOverlayStyle(overlay)" v-show="!hasHotspots(overlay)">
        <div v-show="showAnimatedArrows(overlay)">
          <img class="arrow-animation down-animation" :src="downImage" alt="" />
          <img class="arrow-animation up-animation" :src="upImage" alt="" />
          <img class="arrow-animation left-animation" :src="rightImage" alt="" />
          <img class="arrow-animation right-animation" :src="leftImage" alt="" />
        </div>
        <a href="#" v-on:click.prevent="onObjectClicked(index, overlay.id)" v-show="isSelectable(overlay) && isVisible(overlay)">
          <img :src="getImage(overlay)" @focus="onMouseOver(overlay)" @blur="onMouseOff(overlay)" @mouseover="onMouseOver(overlay)" @mouseout="onMouseOff(overlay)" :class="getObjectDrawMode(false, false, overlay.isMouseOver, overlay.rollover, false, false)" :alt="LG(overlay.alt)" v-on:load="onLoaded(overlay)" />
        </a>

        <div v-show="!isSelectable(overlay) && isVisible(overlay)">
          <!-- <img :src="getImage(overlay)" :class="getObjectDrawMode(false, true, overlay.isMouseOver, null, false, false)" :alt="LG(overlay.alt)" v-on:load="onLoaded(overlay)" /> -->
          <img :src="getImage(overlay)" :class="getObjectDrawMode(false, true, overlay.isMouseOver, null, false, false)" alt="" v-on:load="onLoaded(overlay)" />
        </div>
      </div>
      <div v-for="hotspot in overlay.hotspots" :key="hotspot.id" v-show="isSelectable(overlay)">
        <div v-show="showAnimatedArrows(overlay) && isMapDisplay()" :style="getHotspotStyle(hotspot)">
          <img class="arrow-animation down-animation" :src="downImage" alt="" />
          <img class="arrow-animation up-animation" :src="upImage" alt="" />
          <img class="arrow-animation left-animation" :src="rightImage" alt="" />
          <img class="arrow-animation right-animation" :src="leftImage" alt="" />
        </div>
        <a href="#" v-on:click.prevent="onObjectClicked(index, overlay.id)" :style="getHotspotStyle(hotspot)" @focus="onMouseOver(overlay)" @blur="onMouseOff(overlay)" @mouseover="onMouseOver(overlay)" @mouseout="onMouseOff(overlay)" :aria-label="LG(overlay.alt)"> </a>
      </div>
      <div :style="getOverlayStyle(overlay)" v-show="hasHotspots(overlay)">
        <div v-show="showAnimatedArrows(overlay) && !isMapDisplay()">
          <img class="arrow-animation down-animation" :src="downImage" alt="" />
          <img class="arrow-animation up-animation" :src="upImage" alt="" />
          <img class="arrow-animation left-animation" :src="rightImage" alt="" />
          <img class="arrow-animation right-animation" :src="leftImage" alt="" />
        </div>
        <!-- <img :src="getImage(overlay)" :class="getObjectDrawMode(false, false, overlay.isMouseOver, overlay.rollover, false, overlay.rounded)" :alt="LG(overlay.alt)" v-on:load="onLoaded(overlay)" /> -->
        <img :src="getImage(overlay)" :class="getObjectDrawMode(false, false, overlay.isMouseOver, overlay.rollover, false, overlay.rounded)" alt="" v-on:load="onLoaded(overlay)" />
      </div>
    </div>
    <div v-for="(circle, index) in circles" :key="circle.id">
      <div :style="getOverlayStyle(circle)" v-show="shouldWeShowCircle(circle, index)">
        <div :class="getObjectCircleClass(index)">
          <button v-b-modal.clueRecapsModal1 class="magnifier-button" href="#" v-on:click.prevent="onCircleClicked(index)" @focus="onMouseOver(circle)" @blur="onMouseOff(circle)" @mouseover="onMouseOver(circle)" @mouseout="onMouseOff(circle)" v-show="isSelectable(circle) && isVisible(circle)">
            <img :src="getImage(circle)" :class="getObjectDrawMode(true, true, circle.isMouseOver, circle.rollover, false, false)" alt="Résumé des indices" v-on:load="onLoaded(circle)" />
          </button>
          <div v-show="!isSelectable(circle) && isVisible(circle)">
            <img :src="getImage(circle)" :class="getObjectDrawMode(true, true, false, null, false, false)" alt="" v-on:load="onLoaded(circle)" />
          </div>
        </div>
      </div>
    </div>
    <div :style="getSpinnerStyle()" class="centered-element" v-show="!imagesAllLoaded">
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <img class="centered-element" :src="spinnerUrl" width="20px" height="20px" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayObjects",
  props: {
    overlays: {
      type: Array,
    },
    circles: {
      type: Array,
    },
    id: {
      type: String,
      default: "id-overlay-objects",
    },
    bg: {
      type: String,
    },
    bgwidth: {
      type: String,
    },
    bgheight: {
      type: String,
    },
    alt: {
      type: String,
      default: "",
    },
    labelledby: {
      type: String,
      default: "",
    },
    describedby: {
      type: String,
      default: "",
    },
    arrows: {
      type: String,
      default: "yes",
    },
    map: {
      type: String,
      default: "no",
    },
  },
  data() {
    return {
      // Text

      // Images
      spinnerUrl: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",

      // Variables
      imagesAllLoaded: false,
      testRolloverBoxes: false,
      currentOverlay: null,
      downImage: require("@/assets/menus/popups/arrow_down.png"),
      upImage: require("@/assets/menus/popups/arrow_up.png"),
      rightImage: require("@/assets/menus/popups/arrow_right.png"),
      leftImage: require("@/assets/menus/popups/arrow_left.png"),

      firstRolloverOccurred: false,
    };
  },
  mounted() {
    // Set everything to not yet loaded
    this.imagesAllLoaded = false;
    this.SetAllObjectsLoadedState(false);
  },
  computed: {},
  methods: {
    isMapDisplay() {
      if (this.map == "yes") {
        return true;
      }
      return false;
    },
    getObjectCircleClass(index) {
      if (this.newVersion()) {
        if (index == 5) {
          return "object-circle new-border-color dark-circle-bg";
        } else {
          return "object-circle new-border-color";
        }
      }
      return "object-circle";
    },
    SetAllObjectsLoadedState(value) {
      if (this.overlays != null) {
        for (var i = 0; i < this.overlays.length; i++) {
          if (this.overlays[i].loaded != null) {
            this.overlays[i].loaded = value;
          }
        }
      }
      if (this.circles != null) {
        for (var j = 0; j < this.circles.length; j++) {
          if (this.circles[j].loaded != null) {
            this.circles[j].loaded = value;
          }
        }
      }
    },
    AreAllObjectsLoaded() {
      if (this.overlays != null) {
        for (var i = 0; i < this.overlays.length; i++) {
          if (this.overlays[i].loaded == false) {
            return false;
          }
        }
      }
      if (this.circles != null) {
        for (var j = 0; j < this.circles.length; j++) {
          if (this.circles[j].loaded == false) {
            return false;
          }
        }
      }
      return true;
    },
    getObjectDrawMode(smaller, visible, mouseOver, rollover, isBackground, rounded) {
      var drawType = "img-fluid";
      if (!visible || !this.imagesAllLoaded) {
        if (!mouseOver) {
          drawType = "img-fluid draw-invisible";
        } else if (rollover != null) {
          // Leave out the css highlight if artist made a rollover
          drawType = "img-fluid";
        } else {
          drawType = "img-fluid draw-highlight";
        }
      }

      if (this.newVersion()) {
        if (isBackground || rounded) {
          if (this.isMapDisplay()) {
            drawType = drawType + " rounded-image-with-border";
          } else {
            drawType = drawType + " rounded-image";
          }
        }
      }

      if (smaller) {
        return "overlay-objects-bg object-smaller " + drawType;
      } else {
        return "overlay-objects-bg " + drawType;
      }
    },
    onLoaded(overlay) {
      if (overlay == null || overlay.loaded == null) {
        return;
      }

      overlay.loaded = true;

      // Each time an object loads in, count until all of them are loaded
      //console.log("onLoaded for next object: " + overlay.id);
      if (this.AreAllObjectsLoaded()) {
        this.imagesAllLoaded = true;
      }
    },
    onCircleClicked(index) {
      if (index == 5) {
        this.$emit("search-clicked");
      }
    },
    onObjectClicked(index, modalId) {
      this.$bvModal.show(modalId);
      this.$emit("object-clicked", index);
      this.currentOverlay = null;
    },
    getBackgroundImage(image) {
      return require("../assets/" + image);
    },
    getImage(overlay) {
      if (overlay.rollover != null && overlay.isMouseOver) {
        return require("../assets/" + overlay.rollover);
      } else {
        return require("../assets/" + overlay.image);
      }
    },
    getNumberOfNonEmptyCircles() {
      var count = 0;
      for (var i = 0; i < this.circles.length; i++) {
        if (this.circles[i].image.includes("empty.png") || this.circles[i].image.includes("search.png")) {
          continue;
        }
        count++;
      }
      return count;
    },
    shouldWeShowCircle(circle, index) {
      if (!this.newVersion()) {
        if (index < 5) {
          return true;
        } else {
          return false;
        }
      }

      // If all circles are empty, don't show any
      if (this.getNumberOfNonEmptyCircles() == 0) {
        return false;
      }

      // If it is an empty circle, don't show it
      if (circle.image.includes("empty.png")) {
        return false;
      }

      return true;
    },
    onMouseOver(overlay) {
      if (overlay.isMouseOver != null) {
        overlay.isMouseOver = true;
        this.currentOverlay = overlay;
        //console.log("Mouse over!" + overlay.id);
      }
    },
    onMouseOff(overlay) {
      if (overlay.isMouseOver != null) {
        overlay.isMouseOver = false;

        this.currentOverlay = null; // TBD should we do this?
        //console.log("Mouse off!" + overlay.id);
      }
    },
    hasHotspots(overlay) {
      if (overlay.hotspots != null && overlay.hotspots.length > 0) {
        return true;
      }
      return false;
    },
    isSelectable(overlay) {
      // If the item uses hotspots, don't make it selectable through normal method
      if (overlay.selectable == "no") {
        return false;
      }
      if (overlay.disabled) {
        return false;
      }
      return true;
    },
    isVisible(overlay) {
      if (overlay.visible == "no") {
        return false;
      }
      return true;
    },
    getSpinnerStyle() {
      // This positions a white box the same size as the display area
      var style = "position:relative; top: 0px;  left: 0px;  background-color: white; height: " + this.bgheight + "px; width: " + this.bgwidth + "px;";
      return style;
    },
    getHotspotStyle(hotspot) {
      // Calculate percents based on image width and height and pixels passed in to overlay array
      var x = Number(hotspot.x);
      var y = Number(hotspot.y);
      var width = Number(this.bgwidth);
      var height = Number(this.bgheight);
      var widthPercent = (Number(hotspot.w) / width) * 100;
      var heightPercent = (Number(hotspot.h) / height) * 100;

      var left = (x / width) * 100;
      var top = (y / height) * 100;

      var topStyle = "top: " + top + "%;";
      var leftStyle = "left: " + left + "%; ";
      var widthStyle = "width: " + widthPercent + "%; ";
      var heightStyle = "height: " + heightPercent + "%; ";

      var rollColour = "transparent";
      if (this.testRolloverBoxes) {
        rollColour = "orange";
      }
      var style = "z-index: 1; background-color: " + rollColour + "; position:absolute; " + topStyle + leftStyle + widthStyle + heightStyle;
      //console.log("Style is: " + style);
      return style;
    },
    getOverlayStyle(overlay) {
      // Calculate percents based on image width and height and pixels passed in to overlay array
      var x = Number(overlay.x);
      var y = Number(overlay.y);
      var width = Number(this.bgwidth);
      var height = Number(this.bgheight);
      var widthPercent = (Number(overlay.width) / width) * 100;

      var left = (x / width) * 100;
      var top = (y / height) * 100;

      var topStyle = "top: " + top + "%;";
      var leftStyle = "left: " + left + "%; ";
      var widthStyle = "width: " + widthPercent + "%; ";

      var maxWidthStyle = "";
      if (overlay.maxx != null) {
        var w = Number(overlay.maxx) - x;
        var maxWidthPercent = (w / width) * 100;
        maxWidthStyle = " max-width: " + maxWidthPercent + "%; ";
      }

      var maxHeightStyle = "";
      if (overlay.maxy != null) {
        var h = Number(overlay.maxy) - y;
        var maxHeightPercent = (h / height) * 100;
        maxHeightStyle = " max-height: " + maxHeightPercent + "%; ";
      }

      var style = "position:absolute; " + topStyle + leftStyle + widthStyle + maxWidthStyle + maxHeightStyle;
      //console.log("Style is: " + style);
      return style;
    },
    showAnimatedArrows(overlay) {
      if (this.newVersion() == false) {
        return false;
      }

      if (this.arrows == "no") {
        return false;
      }

      if (overlay == this.currentOverlay) {
        if (!this.firstRolloverOccurred) {
          this.firstRolloverOccurred = true;
          this.$emit("first-rollover");
        }
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.magnifier-button {
  background-color: transparent;
  border: none;
}
.magnifier-button img {
  left: 10% !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.overlay-objects-container {
  position: relative;
  width: 100%;
}

.overlay-objects-bg {
  width: 100%;
}

.draw-invisible {
  opacity: 0;
}

.draw-highlight {
  filter: contrast(1.2);
}

.object-smaller {
  position: relative;
  width: 60px;
  left: 15%;
  top: 10px;
}

.object-circle {
  background-color: white !important;
  height: 90px;
  border-radius: 50%;
  border: 5px solid #3f5d12;
  width: 90px;
}

.new-border-color {
  background-color: #f3f3f3 !important;
  border: 5px solid white !important;
}

.dark-circle-bg {
  background-color: #3f5d12 !important;
}

@media only screen and (max-width: 800px) {
  .object-circle {
    height: 60px;
    width: 60px;
  }

  .object-smaller {
    width: 35px;
  }
}

@-webkit-keyframes uparrow {
  0% {
    -webkit-transform: translateY(0);
    opacity: 0.4;
  }

  100% {
    -webkit-transform: translateY(-0.4em);
    opacity: 0.9;
  }
}

@-webkit-keyframes downarrow {
  0% {
    -webkit-transform: translateY(0);
    opacity: 0.4;
  }

  100% {
    -webkit-transform: translateY(0.4em);
    opacity: 0.9;
  }
}

@-webkit-keyframes rightarrow {
  0% {
    -webkit-transform: translateX(0);
    opacity: 0.4;
  }

  100% {
    -webkit-transform: translateX(-0.4em);
    opacity: 0.9;
  }
}

@-webkit-keyframes leftarrow {
  0% {
    -webkit-transform: translateX(0);
    opacity: 0.4;
  }

  100% {
    -webkit-transform: translateX(0.4em);
    opacity: 0.9;
  }
}

.arrow {
  border-color: transparent;
  border-style: solid;
  border-width: 0 2em;
  display: block;
  height: 0;
  opacity: 0.4;
}

.arrow-display {
  width: 25%;
  height: 25%;
  position: absolute;
  border-color: transparent;
  border-style: solid;
  border-width: 0 2em;
  display: block;
  opacity: 0.4;
  z-index: 0;
}

.up-display {
  -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;
  border-bottom: 2em solid #b6bd02;
  bottom: -40px;
  left: -15px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 50px;
}

.down-display {
  -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;
  border-top: 2em solid #b6bd02;
  top: -40px;
  left: -15px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 50px;
}

.right-display {
  -webkit-animation: rightarrow 0.6s infinite alternate ease-in-out;
  border-right: 2em solid #b6bd02;
  right: -40px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  width: 50px;
  border-top: 2em solid transparent;
  border-bottom: 2em solid transparent;
}

.left-display {
  -webkit-animation: leftarrow 0.6s infinite alternate ease-in-out;
  border-left: 2em solid #b6bd02;
  left: -40px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  width: 50px;
  border-top: 2em solid transparent;
  border-bottom: 2em solid transparent;
}

.arrow-animation {
  position: absolute;
  display: block;
  z-index: 0;
}

.up-animation {
  -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;
  width: 70px;
  bottom: -40px;
  left: -15px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.down-animation {
  -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;
  width: 70px;
  top: -40px;
  left: -15px;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.right-animation {
  -webkit-animation: rightarrow 0.6s infinite alternate ease-in-out;
  width: 40px;
  right: -40px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}

.left-animation {
  -webkit-animation: leftarrow 0.6s infinite alternate ease-in-out;
  left: -40px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  width: 40px;
}

.rounded-image {
  border-radius: 35px;
}

.rounded-image-with-border {
  border: 15px solid white;
  border-radius: 35px;
}
</style>
